export default [
  {
    num: "1.1",
    codename: "Capybara",
    content: [
      "La fonctionnalité Pack Presse est maintenant disponible. Le site internet intègre les crédits des images."
    ]
  },
  {
    num: "1.0.33",
    codename: "Wapiti",
    content: [
      `Le support "présentation de l'agence" est maintenant disponible.`
    ],
  },
  {
    num: "1.0.32",
    codename: "Gypaête Barbu",
    content: [
      "Les axes peuvent maintenant être détaillés avec des Images et la possibilité d'agir sur le mélange aléatoire des images sur le site.",
      "Améliorations d'interfaces.",
    ]
  },
  {
    num: "1.0.31",
    content: [
      "Les paramètres de communication au site web sont maintenant réglables dans l'UI 'Site Internet'",
    ]
  },
  {
    num: "1.0.30",
    content: [
      "Communication de la base de données au site internet lui-même : notifier de changements récents",
    ],
  },
  {
    num: "1.0.29",
    content: [
      "Communication du site internet à la base de données : aller chercher les données",
    ],
  },
  {
    num: "1.0.28",
    content: [
      "Ajout d'options dans la page 'Site internet'. Cela permet de régler le contenu du site, la séquence d'accueil, la disposition de la page d'informations, les axes et projets à mettre en ligne...",
    ],
  },
  {
    num: "1.0.27",
    content: [
      "Ajout du type d'export 'Pack presse'. À noter que la gestion des textes est crédits est à finaliser."
    ]
  },
  {
    num: "1.0.26",
    content: ["Ajout des formulaires de la page 'Agence'"]
  },
  {
    num: "1.0.25",
    content: ['Signatures mail dans la rubrique "Outils divers"']
  },
  {
    num: "1.0.24",
    content: ["Réglages de bugs d'impression"]
  },
  {
    num: "1.0.23",
    content: ["Ajout des fichettes A5, première version"]
  },
  {
    num: "1.0.22",
    content: [
      "Mise à jour de Morris",
      "Ajout de l'affichage de Maîtres d'oeuvre multiples."
    ]
  },
  {
    num: "1.0.21",
    content: ["Changement de système de notes de version"]
  },
  {
    num: "1.0.20",
    content: ['Ajout d\'un export "Fiches récapitulatives" à usage interne.']
  },
  {
    num: "1.0.19",

    content: ["Formatage des dates"]
  },
  {
    num: "1.0.18",
    content: [
      "Intégration partielle de <em>Morris</em>",
      "Ajout de systèmes de surveillance de santé de l'app"
    ]
  },

  {
    num: "1.0.17",
    content: [
      "Amélioration UI de l'impression de projets",
      "Autorisation de l'usage de l'axe \"générique\""
    ]
  },

  {
    num: "1.0.16",
    content: [
      'Possibilité, dans la page "Cherchables", de renommer et fusionner des items.'
    ]
  },

  {
    num: "1.0.15",
    content: ['La page "Exporter" est simplifiée dans sa manipulation.']
  },

  {
    num: "1.0.14",
    content: [
      ' La page "Éditer un projet" est revue en prévision de modifications à venir.',
      'La page "Voir un projet" est encore simplifiée.'
    ]
  }
];
